module.exports = __webpack_public_path__ + "static/media/leaf-footer.b85bd099.svg";